import { getCurrentInstance } from 'vue';

export function useOptions() {
  const currentInstance = getCurrentInstance();

  return currentInstance?.proxy.$options;
}
